export const areaUtil = (area) => ({
  ...area,

  isOwner(user) {
    // checkear si el responsable y/o lider del area es el usuario
    const { liderId, responsableId } = this;
    return (liderId && liderId === user.Pi.itemId) || (responsableId && responsableId === user.Pi.itemId);
  },
});
